<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <strong>{{request}}</strong>
            </div>
            <div class="card-block" >

              <img v-if="!curl" src="static/img/loading.gif" height="32"/>

              <div v-if="curl">
                <pre v-highlightjs='curl.curl'><code class="bash"></code></pre>
                <pre v-highlightjs='curl.response'><code class="json"></code></pre>
              </div>

            </div>
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'curl-response',
  props: ['curl', 'request']
}
</script>



// WEBPACK FOOTER //
// src/components/CurlResponse.vue